"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hiverAxiosCall = exports.performAxiosCall = void 0;
var axios_1 = require("axios");
var utils_1 = require("./utils");
var fetchAccessToken_1 = require("./fetchAccessToken");
var storage_1 = require("./utils/storage");
var hiverAuthToken;
var MAX_403_RETRY = 2;
var addCsrfToken = function (params, configHiver) {
    var csrfToken = configHiver.fetchCsrfToken();
    if (params.formData) {
        params.formData.append('_csrf_token', csrfToken);
    }
    else {
        params.data = params.data || {};
        params.data._csrf_token = csrfToken;
    }
};
var getAxiosConfig = function (params) {
    var requestData = !params.method || params.method.toLowerCase() === 'get'
        ? { params: params.data }
        : { data: params.data };
    var config = __assign(__assign({ method: params.method, url: "".concat(params.root_url).concat(params.url), headers: params.headers }, requestData), { withCredentials: params.withCredentials, responseType: (params === null || params === void 0 ? void 0 : params.responseType) || '' });
    return config;
};
function performAxiosCall(params) {
    return __awaiter(this, void 0, void 0, function () {
        var axiosConfig;
        return __generator(this, function (_a) {
            axiosConfig = getAxiosConfig(params);
            return [2, (0, axios_1.default)(axiosConfig)
                    .then(function (response) {
                    return response;
                })
                    .catch(function (error) {
                    throw error;
                })];
        });
    });
}
exports.performAxiosCall = performAxiosCall;
function fetchAuthToken(bifrostInstance, appEnv, tier, apiParams, isHiverApiDomain, origin) {
    return __awaiter(this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 6, , 8]);
                    if (!!bifrostInstance.authTokenFetchingInProgress) return [3, 2];
                    bifrostInstance.authTokenFetchingInProgress = true;
                    return [4, (0, fetchAccessToken_1.fetchAccessToken)(appEnv, tier, apiParams, isHiverApiDomain, origin)];
                case 1:
                    _a.sent();
                    bifrostInstance.authTokenFetchingInProgress = false;
                    return [3, 5];
                case 2: return [4, new Promise(function (resolve) { return setTimeout(resolve, 100); })];
                case 3:
                    _a.sent();
                    console.log('Heimdall: Retrying fetchAccessToken after 100ms...');
                    return [4, fetchAuthToken(bifrostInstance, appEnv, tier, apiParams, isHiverApiDomain, origin)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5: return [3, 8];
                case 6:
                    error_1 = _a.sent();
                    console.log('Error while fetching Auth Token :', error_1);
                    bifrostInstance.authTokenFetchingInProgress = false;
                    return [4, fetchAuthToken(bifrostInstance, appEnv, tier, apiParams, isHiverApiDomain, origin)];
                case 7:
                    _a.sent();
                    return [3, 8];
                case 8: return [2];
            }
        });
    });
}
function hiverAxiosCall(bifrostInstance, params, configHiver, origin, _$retryCount) {
    var _a, _b;
    if (_$retryCount === void 0) { _$retryCount = 0; }
    return __awaiter(this, void 0, void 0, function () {
        var appEnv, tier, apiParams, response, error_2, is403Error;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 4, , 5]);
                    if (!(configHiver.getToken && !(0, utils_1.hasValidToken)(params))) return [3, 2];
                    appEnv = params.appEnv, tier = params.tier;
                    if (!appEnv || !tier) {
                        throw Error("appEnv or tier missing : ".concat(appEnv, "/").concat(tier));
                    }
                    if (!('userId' in params && 'usergroupId' in params)) return [3, 2];
                    apiParams = {
                        userId: params.userId,
                        usergroupId: params.usergroupId,
                    };
                    if (typeof configHiver.isHiverApiDomain !== 'boolean') {
                        configHiver.isHiverApiDomain = true;
                    }
                    return [4, fetchAuthToken(bifrostInstance, appEnv, tier, apiParams, configHiver.isHiverApiDomain, origin)];
                case 1:
                    _c.sent();
                    _c.label = 2;
                case 2:
                    if (params.csrfToken) {
                        addCsrfToken(params, configHiver);
                    }
                    if (configHiver.getToken) {
                        hiverAuthToken = (0, storage_1.getItemFromStorage)('hiverAuthToken') || '';
                        params.headers = __assign(__assign({}, params.headers), { Authorization: "Bearer ".concat(hiverAuthToken) });
                    }
                    console.log('Performing axios call for:', params);
                    return [4, performAxiosCall(params)];
                case 3:
                    response = _c.sent();
                    if (params.onSuccess) {
                        params.onSuccess(response);
                    }
                    return [2, response];
                case 4:
                    error_2 = _c.sent();
                    is403Error = ((_a = error_2.response) === null || _a === void 0 ? void 0 : _a.status) === 403 || ((_b = error_2.request) === null || _b === void 0 ? void 0 : _b.status) === 403;
                    if (_$retryCount < MAX_403_RETRY && is403Error) {
                        (0, utils_1.expireToken)();
                        return [2, hiverAxiosCall(bifrostInstance, params, configHiver, origin, _$retryCount + 1)];
                    }
                    else if ((_$retryCount >= MAX_403_RETRY && is403Error) || !is403Error) {
                        if (params.onFail) {
                            params.onFail(error_2);
                        }
                        console.log('ERROR: Reached make Axios', error_2);
                        throw error_2;
                    }
                    return [3, 5];
                case 5: return [2];
            }
        });
    });
}
exports.hiverAxiosCall = hiverAxiosCall;
//# sourceMappingURL=Axios.js.map